<template>
  <div class="load-bag" v-if="showLoader">
  <div class="lds-ripple" ><div></div><div></div></div>
  </div>
    <Dashboard/>
     <!-- Main Content -->
     <div class="main-content">
       <section class="section">
         <div class="section-header">
           <h1>Content Management</h1>
           <div class="section-header-breadcrumb">
             <div class="breadcrumb-item active"><router-link to="/dashboard">Home</router-link></div>
             <div class="breadcrumb-item">Content Management</div>
           </div>
         </div>
         <div class="section-body">
           <div class="row">
             <div class="col-12">
               <div class="card">
                 <div class="card-header d-Fle">
                   <h4 class="hide">Export Table</h4>
                   <!-- <a
                     href=""
                     data-toggle="modal"
                     data-target=".add-modal-content"
                     >Add Content</a
                   > -->
                   <!-- <router-link
                    to="/addcontent"
                     >Add Content</router-link
                   > -->
                 </div>
                 <div class="card-body">
                   <div class="table-responsive newPc">
                     <table 
                       class="table table-bordered table-hover"
                       id="tableExport"
                       style="width: 100%"
                     >
                       <thead>
                         <tr>
                           <th>S No.</th>
                           <th>Title</th>
                           <th>Content</th>
                           <th>Action</th>
                         </tr>
                       </thead>
                       <tbody>
                         <tr v-for="(item, index) in result" :key="item.id">
                           <td>{{index+1}}</td>
                           <td >{{item.title.replace(/^./, item.title[0].toUpperCase())}}</td>
                           <td class="text-justify" v-html="item.description.replace(/^./, item.description[0].toUpperCase())"> </td>
                           <td class="action">
                             <a data-toggle="modal"  
                             data-target=".edit-modal-content" @click="ViewContent(item._id)"
                             ><i class="far fa-edit"></i
                              ></a>
                              <a data-toggle="modal"  @click="ViewContent(item._id)"
                              data-target=".view-content-modal"
                              ><i class="far fa-eye"></i
                                ></a>
                          </td>
                         </tr>
                       </tbody>
                     </table>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div> 
       </section>
     </div>

      <!-- View content Modal start -->
      <div
        class="modal fade view-content-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Details</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="custom-table forscroll">
                  <table class="table-bordered w-100">
        <tbody>
            <tr>
            <th class="p-3"> Title</th>
            <td class="p-3">{{ this.viewtitle }}</td>
            </tr>
            <tr>
            <th class="p-3 content" >Content</th>
            <td class="p-3 text-justify" >{{ this.viewmessage }}</td>
            </tr>
        </tbody>
    </table>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- View User Modal end -->

     <!-- Add Content Modal start -->
     <div
       class="modal fade add-modal-content"
       tabindex="-1"
       role="dialog"
       aria-labelledby="myLargeModalLabel"
       aria-hidden="true"
     >
       <div class="modal-dialog modal-lg">
         <div class="modal-content">
           <div class="modal-header">
             <h5 class="modal-title" id="myLargeModalLabel">Add Content</h5>
             <button
               type="button"
               class="close"
               data-dismiss="modal"
               aria-label="Close"
               @click="cross()"
             >
               <span aria-hidden="true">&times;</span>
             </button>
           </div>
           <div class="modal-body">
             <div class="row">
               <div class="col-lg-4 col-md-12 col-sm-12">
                 <div class="form-group">
                   <label>Title</label>
                   <input type="text" v-model="title" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Content</label>
                    <textarea type="text" v-model="content"  class="form-control" ></textarea>
                    <!-- <ckeditor :editor="editor" id="editor" v-model="content" :config="editorConfig"></ckeditor> -->
                  </div>
                </div>
               <div class="col-lg-12 col-md-12 col-sm-12">
                 <input type="button" @click="AddContent" value="Add Details" class="modal-btn" />
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
     <!-- Add Content Modal end -->

     <!-- Edit Content Modal start -->
     <div
       class="modal fade edit-modal-content"
       tabindex="-1"
       role="dialog"
       aria-labelledby="myLargeModalLabel"
       aria-hidden="true"
     >
       <div class="modal-dialog modal-lg">
         <div class="modal-content">
           <div class="modal-header">
             <h5 class="modal-title" id="myLargeModalLabel">
               Edit  Details
             </h5>
             <button
               type="button"
               class="close"
               data-dismiss="modal"
               aria-label="Close"
             >
               <span aria-hidden="true">&times;</span>
             </button>
           </div>
           <div class="modal-body">
             <div class="row">
              <div class="col-lg-4 col-md-12 col-sm-12">
                 <div class="form-group">
                   <label>Title</label>
                   <input type="text" v-model="viewtitle" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Content</label>
                    <textarea type="text" v-model="viewmessage"  class="form-control text-justify" ></textarea>
                    <!-- <ckeditor :editor="editor" id="editor" v-model="viewmessage" :config="editorConfig"></ckeditor> -->
                  </div>
                </div>
               <div class="col-lg-12 col-md-12 col-sm-12">
                 <input
                   type="button"
                   value="Update Details"
                   @click="UpdateContent(viewid)"
                   class="modal-btn"
                 />
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
     <!-- Edit Content Modal end -->
</template>
<script>
import { defineComponent } from 'vue'
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
// import CKEditor from "@ckeditor/ckeditor5-vue";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Dashboard from '@/components/Dashboard.vue'
import axios from "../services/customAxios";
import { base_url } from "../config";
export default defineComponent({
 name: 'Content',
 components: {
   Dashboard,
  //  ckeditor: CKEditor.component,
 },
 setup () {
    const toast = () => {
        createToast()
    }
    return { toast }
  },
 data(){
   return{
    //  editor: ClassicEditor,
    //  editorData: "<p>Content of the editor.</p>",
    //  editorConfig: {
    //   // The configuration of the editor.
    //  },
     result:[],       
     base_url: base_url,
     title: "",
     content: "",
     viewtitle:"",
     viewmessage:"",
     viewid:"",
     showLoader: true,
    }
 },
 methods:{
   async LoadContent() {
     try{
     let response = await axios.get(`${base_url}/get_all_content`); 
    //  console.log(">>>===>>>===>>>",response.data.data);
     this.result = response.data.result.reverse();
   }
   catch (error) {
     if (error) {
       this.showLoader= false;
         this.result = [];
       }
     }
   },
   async ViewContent(_id){
      let response= await axios.get(`${base_url}/get_content/`+ _id );
      // console.log("=====View Content=====>>>>>",response.data.result);
      this.viewtitle = response.data.result.title;
      this.viewmessage = response.data.result.description;
      this.viewid= response.data.result._id
   },
   cross(){
    window.location.reload();
   },
   async UpdateContent(viewid) {
    try{
     const response = await axios.put(
       `${base_url}/update_content/` + viewid,{
         title: this.viewtitle,
         description: this.viewmessage,
       }
     );
    //  console.log("result", response.data);
     createToast({title: "Success", description: response.data.message},{type: "success"})
     if(response.data.success == true){
         window.location.reload();
       }
      }
      catch(error){
        createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
      }
   },
 },
 async mounted(){
   this.LoadContent()
   this.ViewContent()
   let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'assets/pages/datatables.js');
    setTimeout(() => {
      document.body.appendChild(recaptchaScript)  
      this.showLoader= false
    }, 2000);
 }
});
</script>

<style scoped>
.forscroll{
  overflow-y: scroll;
    height: 500px;

}
.modal.show .modal-dialog {
    transform: translateY(10%);
}
.content{
  display: block;
    border: none;
    width: 120px;
}
.text-justify{
  text-align: justify;
}
</style>